import { TypedDocumentString } from './generated/graphql';

export async function execute<TResult>(uri: string) {
  const url = new URL(
    `${process.env.WORDPRESS_URL}/wp-content/uploads/headless-cache/page-${uri}.json`,
  );

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/graphql-response+json',
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const json = await response.json();

  if (json.errors) {
    throw new Error(json.errors[0].message);
  }

  return json.data as TResult;
}

export async function executeModule<TResult>(uri: string) {
  const url = new URL(
    `${process.env.WORDPRESS_URL}/wp-content/uploads/headless-cache/module-${uri}.json`,
  );

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/graphql-response+json',
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const json = await response.json();

  if (json.errors) {
    throw new Error(json.errors[0].message);
  }

  return json.data as TResult;
}

export async function executeGraphql<TResult, TVariables>(
  query: TypedDocumentString<TResult, TVariables>,
  variables?: TVariables,
  cache?: boolean,
) {
  const url = `${process.env.WORDPRESS_URL}/graphql`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/graphql-response+json',
    },
    body: JSON.stringify({ query: query.toString(), variables }),
    cache: cache ? 'force-cache' : 'no-store',
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const json = await response.json();

  if (json.errors) {
    throw new Error(json.errors[0].message);
  }

  return json.data as TResult;
}
